<template>
  <div class="card-body meters">
    <!-- Status Dot -->
    <div v-if="!activeMeterInfo.Removed" class="dot-active float-right"></div>
    <div v-else class="dot float-right"></div>
    <div class="all_meter_info mt-3" v-if="activeMeterInfo && activeConfigInfo">
      <!-- Meter Serial -->
      <div class="meter serial pb-2">
        <h6 class="d-inline-block pr-2">Meter Serial:</h6>
        <p class="d-inline-block">{{ activeMeterInfo.Serial }}</p>
      </div>
      <div>
        <img
          src="@/assets/img/barcode.png"
          class="img-fluid pb-2"
          alt="Barcode"
        />
      </div>
      <!-- Meter Type -->
      <div class="meter_info">
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Meter Type:</p>
          </div>
          <div class="d-inline-block right">
            <p class="text-capitalize">{{ activeMeterInfo.MeterType }}</p>
          </div>
        </div>
        <!-- SSC Code -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">SSC Code:</p>
          </div>
          <div class="d-inline-block right">
            <a
              class="pointer"
              data-toggle="modal"
              data-target="#ViewSscInfo"
              @click="getSscInfo()"
            >
              <p class="link">{{ sscValue }}</p>
            </a>
          </div>
        </div>
        <!-- TPR -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">TPR:</p>
          </div>
          <div class="d-inline-block right">
            <p>
              <span v-for="(tpr, index) in tprs" :key="tpr.SharedId">
                <span v-if="index > 0">,</span>
                {{ tpr.Tpr }}
              </span>
            </p>
            <!-- <p>{{ getTprs() }}</p> -->
          </div>
        </div>
        <!-- Retrieval Method -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Retrieval Method:</p>
          </div>
          <div class="d-inline-block right">
            <p>{{ activeConfigInfo.RetrievalMethod }}</p>
          </div>
        </div>
        <!-- Automated Readings -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Automated Readings:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.IsAmr">True</p>
            <p v-else>False</p>
          </div>
        </div>
        <!-- Eac Total -->
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">EAC Total:</p>
          </div>
          <div class="d-inline-block right">
            <p>{{ eacTotal }}</p>
          </div>
        </div>
        <!-- Eac By TPR -->
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">EAC By TPR:</p>
          </div>
          <div class="d-inline-block right" v-if="eac">
            <p v-for="tpr in tprs" :key="tpr.SharedId">
              {{ tpr.Tpr }} = {{ getEac(tpr.Tpr) }}
            </p>
          </div>
        </div>
        <!-- Reg. Multiplier By TPR -->
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Reg. Multiplier By TPR:</p>
          </div>
          <div class="d-inline-block right" v-if="tprs">
            <p v-for="register in tprs" :key="register.SharedId">
              {{ register.Tpr }} = {{ register.Multiplier.toFixed(2) }}
            </p>
          </div>
        </div>
        <!-- Location -->
        <div class="mb-4 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Location:</p>
          </div>
          <div class="d-inline-block right" v-if="activeConfigInfo">
            <p>{{ activeConfigInfo.Location | splitString }}</p>
          </div>
        </div>
        <!-- Install Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Install Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.Installed">
              {{ activeMeterInfo.Installed | shortDate }}
            </p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Removed Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Removed Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.Removed">
              {{ activeMeterInfo.Removed | shortDate }}
            </p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Last Validated Read -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold text-white">Last Validated Read:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="lastValidReading">{{ lastValidReading | shortDate }}</p>
            <p v-else>N/A</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import elecMetersMixin from "@/mixins/meterInfo/meters/elecMeters.js";

export default {
  name: "electricityMeterNhh",
  mixins: [elecMetersMixin],
  computed: {
    sscValue() {
      return this.activeMeterPointConfig.Ssc;
    },
    tprs() {
      return this.$_.filter(
        this.activeConfigInfo.Registers,
        function (register) {
          return (
            register.IsSettlement && register.BillingTypeId != "NotApplicable"
          );
        }
      );
    },
    eac() {
      return this.activeService.MeterPoint.Eacs.filter((eac) =>
        moment(eac.EffectiveFrom).isBetween(
          this.activeConfigInfo.EffectiveFrom,
          this.activeConfigInfo.EffectiveTo,
          "days",
          "[)"
        )
      ).sort((a, b) =>
        moment(a.EffectiveFrom).isAfter(b.EffectiveFrom) ? -1 : 1
      )[0];
    },
    eacTotal() {
      if (!this.eac) return "Unknown";
      else {
        let eacTotal = 0;
        this.eac.Tprs.forEach((tpr) => {
          eacTotal += tpr.Value;
        });
        return eacTotal;
      }
    },

    lastValidReading() {
      let lastReading = this.activeService.Readings.find(
        (reading) => reading.ValidationStatus === "Valid"
      );
      return lastReading ? lastReading.ReadingDate : undefined;
    },
  },
  methods: {
    getSscInfo() {
      this.$store.dispatch("getSscInfo", this.sscValue);
    },
    getEac(tprCode) {
      return this.$_.find(this.eac.Tprs, (tpr) => {
        return tpr.Tpr === tprCode;
      }).Value;
    },
  },
};
</script>

<style lang="css" scoped>
.link {
  color: blue;
  text-decoration: underline;
}
</style>